/**
 * @desc Here will be list of mutation for store
 */

export const SET_AUTH_TOKENS = 'SET_AUTH_TOKENS'
export const CREATE_SUCCESS_MESSAGE = 'CREATE_SUCCESS_MESSAGE'
export const CREATE_ERROR_MESSAGE = 'CREATE_ERROR_MESSAGE'
export const HIDE_MESSAGE = 'HIDE_MESSAGE'
export const LOG_OUT_USER = 'LOG_OUT_USER'
export const SET_PACKAGE_LIST = 'SET_PACKAGE_LIST'
export const SET_PREDEFINED_ACTIVITY = 'SET_PREDEFINED_ACTIVITY'
export const SET_SPINNER_STATUS = 'SET_SPINNER_STATUS'
export const SET_CATEGORIES_LIST = 'SET_CATEGORIES_LIST'
export const SET_REGULAR_ATTENDEE_TYPE = 'SET_REGULAR_ATTENDEE_TYPE'
export const SET_ATTENDEE_REMINDERS_SETTINGS = 'SET_ATTENDEE_REMINDERS_SETTINGS'
export const SET_COMPANIES_LIST = 'SET_COMPANIES_LIST'
export const SET_SPEAKERS_LIST = 'SET_SPEAKERS_LIST'
export const SET_SPEAKERS_PAGE_SETTINGS = 'SET_SPEAKERS_PAGE_SETTINGS'
export const SET_USERS_LIST = 'SET_USERS_LIST'
export const SAVE_INTERPRITATION_FORM = 'SAVE_INTERPRITATION_FORM'
export const SAVE_CURRENT_FORM = 'SAVE_CURRENT_FORM'
export const SET_SPONSORS_LIST = 'SET_SPONSORS_LIST'
export const SET_SPONSORS_TASKS_LIST = 'SET_SPONSORS_TASKS_LIST'
export const SET_SPONSORS_TYPES_LIST = 'SET_SPONSORS_TYPES_LIST'
export const SET_SPONSORS_TIERS_LIST = 'SET_SPONSORS_TIERS_LIST'
export const SET_SPONSORS_TAGS_LIST = 'SET_SPONSORS_TAGS_LIST'
export const SET_SPONSORS_SETTINGS = 'SET_SPONSORS_SETTINGS'

export const SEND_SINGLE_LETTER = 'SEND_SINGLE_LETTER'
export const SET_LETTER_MODAL_VISIBILITY = 'SET_LETTER_MODAL_VISIBILITY'

export const SET_CSV_FILE_UPLOAD_PROGRESS = 'SET_CSV_FILE_UPLOAD_PROGRESS'
export const SET_VALIDATION_ERROR_MESSAGE = 'SET_VALIDATION_ERROR_MESSAGE'
export const SET_STATUS_VALIDATION_ERROR_MESSAGE = 'SET_STATUS_VALIDATION_ERROR_MESSAGE'
export const SET_BLITZ_SUBMITS = 'SET_BLITZ_SUBMITS'
export const SET_COUNTER_BLITZ = 'SET_COUNTER_BLITZ'
export const SET_GALLERIES_LIST = 'SET_GALLERIES_LIST'

export const STATUS_DISPLAY_NAME = 'STATUS_DISPLAY_NAME'

export const SET_LOCATIONS_LIST = 'SET_LOCATIONS_LIST'
export const SET_VIP_ATTENDEE_TYPE = 'SET_VIP_ATTENDEE_TYPE'
export const SET_SESSIONS_LIST = 'SET_SESSIONS_LIST'

export const SET_AGENDA_SETTINGS = 'SET_AGENDA_SETTINGS'

export const SEND_VIP_SINGLE_LETTER = 'SEND_VIP_SINGLE_LETTER'
export const SET_VIP_ATTENDEE_TYPES = 'SET_VIP_ATTENDEE_TYPES'
export const GET_TAG = 'GET_TAG'
export const GET_TAG_BY_TYPE = 'GET_TAG_BY_TYPE'

export const SAVE_CURRENT_SPEAKER = 'SAVE_CURRENT_SPEAKER'
export const CHANGE_SPEAKER_STATUS = 'CHANGE_SPEAKER_STATUS'
export const SET_SPEAKER_SETTINGS = 'SET_SPEAKER_SETTINGS'
export const SET_SPEAKERS_HOMEPAGE_LIST = 'SET_SPEAKERS_HOMEPAGE_LIST'

export const SET_NOMINEES_LIST = 'SET_NOMINEES_LIST'
export const SET_NOMINEES_LIST_WITH_WINNER_STATUS = 'SET_NOMINEES_LIST_WITH_WINNER_STATUS'

export const SET_NOMINATIONS_CATEGORIES = 'SET_NOMINATIONS_CATEGORIES'

export const SET_SPONSOR_TIERS_LIST = 'SET_SPONSOR_TIERS_LIST'
export const SET_SPONSOR_TYPES_LIST = 'SET_SPONSOR_TYPES_LIST'
export const SET_SPONSOR_TASKS_LIST = 'SET_SPONSOR_TASKS_LIST'
export const SET_MEDIA_KITS = 'SET_MEDIA_KITS'

export const SET_EMAIL_TEMPLATES = 'SET_EMAIL_TEMPLATES'

export const SET_PROMO_CODES_LIST = 'SET_PROMO_CODES_LIST'

export const SET_REGULAR_ATTENDEE_LIST = 'SET_REGULAR_ATTENDEE_LIST'
export const SET_VIP_ATTENDEE_LIST = 'SET_VIP_ATTENDEE_LIST'

export const SET_STATIC_CONTENT = 'SET_STATIC_CONTENT'
export const SET_ENABLED_CATEGORIES_LIST = 'SET_ENABLED_CATEGORIES_LIST'

export const SET_FILES = 'SET_FILES'
export const SET_FEATURED_ATTENDEE_PAGE_SETTINGS = 'SET_FEATURED_ATTENDEE_PAGE_SETTINGS'
export const SET_TESTIMONIALS_LIST = 'SET_TESTIMONIALS_LIST'
export const SET_SETTINGS = 'SET_SETTINGS'
export const SET_USER_SCOPES = 'SET_USER_SCOPES'
export const SET_SCOPES_LIST = 'SET_SCOPES_LIST'

export const SET_VIDEOS_LIST = 'SET_VIDEOS_LIST'
export const SET_VIDEOS_DISPLAY_SETTINGS = 'SET_VIDEOS_DISPLAY_SETTINGS'

export const SET_BANNERS_LIST = 'SET_BANNERS_LIST'
export const SET_PAGE_WITH_BANNER = 'SET_PAGE_WITH_BANNER'
export const SET_BANNERS_DISPLAY_SETTINGS = 'SET_BANNERS_DISPLAY_SETTINGS'

export const UPDATE_ACCESS_TOKEN = 'UPDATE_ACCESS_TOKEN'

export const SET_COOKIES_ALERT_SETTINGS = 'SET_COOKIES_ALERT_SETTINGS'
export const SET_GENERAL_SETTINGS = 'SET_GENERAL_SETTINGS'

export const SET_PHOTO_GALLERIES_LIST = 'SET_PHOTO_GALLERIES_LIST'
export const SET_TESTIMONIAL_TYPES = 'SET_TESTIMONIAL_TYPES'
export const SET_LAST_YEAR_TESTIMONIALS = 'SET_LAST_YEAR_TESTIMONIALS'
export const SET_LAST_YEAR_TESTIMONIALS_DISPLAY = 'SET_LAST_YEAR_TESTIMONIALS_DISPLAY'

export const SET_PUBLIC_LAST_YEAR_TESTIMONIALS = 'SET_PUBLIC_LAST_YEAR_TESTIMONIALS'
export const SET_TESTIMONIALS_DISPLAY_SETTINGS = 'SET_TESTIMONIALS_DISPLAY_SETTINGS'

export const SET_BLOCK_ATTENDEE_SETTINGS = 'SET_BLOCK_ATTENDEE_SETTINGS'
export const SET_IMAGE_URL = 'SET_IMAGE_URL'

export const SET_LAST_YEAR_ATTENDEES = 'SET_LAST_YEAR_ATTENDEES'

export const SET_LISTING = 'SET_LISTING'
export const SET_COUNTER_LISTING = 'SET_COUNTER_LISTING'
export const SET_LISTING_PAYLOAD = 'SET_LISTING_PAYLOAD'

export const SET_KILLER_FEATURE_DISPLAY_SETTINGS = 'SET_KILLER_FEATURE_DISPLAY_SETTINGS'

export const SET_VIP_ATTENDEE_STATUSES_COUNT = 'SET_VIP_ATTENDEE_STATUSES_COUNT'
export const SET_REGULAR_ATTENDEE_STATUSES_COUNT = 'SET_REGULAR_ATTENDEE_STATUSES_COUNT'
export const SET_ALL_ATTENDEE_STATUSES_COUNT = 'SET_ALL_ATTENDEE_STATUSES_COUNT'
export const SET_CRYPTO_TRADERS_LIST = 'SET_CRYPTO_TRADERS_LIST'
export const SET_CRYPTO_TRADER_PACKAGES = 'SET_CRYPTO_TRADER_PACKAGES'

export const SET_VOUCHER_PAGE_SETTINGS = 'SET_VOUCHER_PAGE_SETTINGS'

export const SET_VIP_INVITATION = 'SET_VIP_INVITATION'
export const SET_VIP_INVITATION_PACKAGE = 'SET_VIP_INVITATION_PACKAGE'
export const SET_BATCHED_INVITATIONS = 'SET_BATCHED_INVITATIONS'

export const SET_ADMIN_NOTIFICATION_SETTINGS = 'SET_ADMIN_NOTIFICATION_SETTINGS'
export const SET_ATTENDEE_NOTIFICATION_SETTINGS = 'SET_ATTENDEE_NOTIFICATION_SETTINGS'
export const SET_ALL_ATTENDEE = 'SET_ALL_ATTENDEE'

export const SET_VOTING_STEP_ONE = 'SET_VOTING_STEP_ONE'
export const SET_VOTING_STEP_TWO = 'SET_VOTING_STEP_TWO'
export const SET_VOTING_STATISTICS_STEP_ONE = 'SET_VOTING_STATISTICS_STEP_ONE'
export const SET_VOTING_STATISTICS_STEP_TWO = 'SET_VOTING_STATISTICS_STEP_TWO'

export const SET_VOTING_STEP_ONE_INDIVIDUAL = 'SET_VOTING_STEP_ONE_INDIVIDUAL'
export const SET_VOTING_STEP_TWO_INDIVIDUAL = 'SET_VOTING_STEP_TWO_INDIVIDUAL'
export const SET_VOTING_STATISTICS_STEP_ONE_INDIVIDUAL = 'SET_VOTING_STATISTICS_STEP_ONE_INDIVIDUAL'
export const SET_VOTING_STATISTICS_STEP_TWO_INDIVIDUAL = 'SET_VOTING_STATISTICS_STEP_TWO_INDIVIDUAL'

export const SET_ATTENDEES_MESSAGES = 'SET_ATTENDEES_MESSAGES'

export const SET_INVOICE_LIST = 'SET_INVOICE_LIST'

export const SET_AWARDS_REMINDERS = 'SET_AWARDS_REMINDERS'

export const SET_SEND_GRID_TEMPLATES = 'SET_SEND_GRID_TEMPLATES'

export const SET_GOOGLE_CREDENTIALS = 'SET_GOOGLE_CREDENTIALS'
export const SET_GOOGLE_ACCESS_LINK = 'SET_GOOGLE_ACCESS_LINK'
export const SET_GOOGLE_PIXEL_SETTING = 'SET_GOOGLE_PIXEL_SETTING'

export const SET_ATTENDEES_ALL_MESSAGES = 'SET_ATTENDEES_ALL_MESSAGES'

export const SET_NEWS_LIST = 'SET_NEWS_LIST'

export const SET_SEGMENTS_LIST = 'SET_SEGMENTS_LIST'

export const SET_REGULAR_INVITATIONS = 'SET_REGULAR_INVITATIONS'

export const SET_USER_DETAILS = 'SET_USER_DETAILS'
export const SET_ID_OF_CURRENT_USER = 'SET_ID_OF_CURRENT_USER'
export const SET_USERS_ACTIONS = 'SET_USERS_ACTIONS'

export const SET_FORBIDDEN_EMAIL_DOMAINS = 'SET_FORBIDDEN_EMAIL_DOMAINS'

export const SET_SIGNALR_CONNECTED = 'SET_SIGNALR_CONNECTED'
export const SET_SIGNALR_DISCONNECTED = 'SET_SIGNALR_DISCONNECTED'
export const SET_SIGNALR_INVOKE_STATUS = 'SET_SIGNALR_INVOKE_STATUS'

export const SET_STYLES_SETTINGS = 'SET_STYLES_SETTINGS'
export const RESET_STYLES_SETTINGS = 'RESET_STYLES_SETTINGS'
export const SET_BATCHED_INVITATION_ATTENDEES = 'SET_BATCHED_INVITATION_ATTENDEES'

export const SET_BLACK_LIST = 'SET_BLACK_LIST'
export const SET_BLOCKEDIPS_LIST = 'SET_BLOCKEDIPS_LIST'
export const SET_VOTING_VOTERS = 'SET_VOTING_VOTERS'
export const SET_USERS_ACTIONS_TYPES = 'SET_USERS_ACTIONS_TYPES'

export const SET_MAP_LOCATIONS = 'SET_MAP_LOCATIONS'
export const SET_MAP_SVG = 'SET_MAP_SVG'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js